// import { ServiceAppService } from '../../../security/service-app.service';
// import { FileUpload } from '../../../shared/fileupload/fileupload';
// import { Component, Input, OnInit, ViewChild } from '@angular/core';
// import { ConfirmationService, MessageService, PrimeNGConfig } from 'primeng/api';
// import { Table } from 'primeng/table';
// import { ExportExcelService } from '../../../shared/excel-service/export-excel.service';
// import * as XLSX from 'xlsx';
// import { Estado } from '../../../shared/shared/estado.enum';
// import { ICadastro, IFiltros } from './interface-porcentual';

// @Component({
//   selector: 'app-porcentual-clv',
//   templateUrl: './porcentual-clv.component.html',
//   styleUrls: ['./porcentual-clv.component.scss'],
// })
// export class PorcentualClvComponent implements OnInit {

//   editingRows: { [key: string]: boolean } = {}
//   cols: any[];
//   first = 0;
//   rows = 10;
//   dados: any[] = [];
//   _selectedColumns: any[] = [];
//   loading: boolean = false;
//   nomeModulo: string = 'previsao-venda';
//   totalRegistros: any = 0;
//   filtrosNew: IFiltros = {
//     id: '', id_dealer: '', id_categoria_venda: '', mes: '', ano: '', paginaAtual: 1,
//     quantidadeRegistrosPorPagina: 10, anoNumber: new Date().getFullYear()
//   };
//   selectedDados: any[] = [];

//   @ViewChild('dt') dt: Table;
//   @ViewChild('fileUploader') fileUpload: FileUpload;

//   constructor(private service: ServiceAppService, private messageService: MessageService, private exportExcelService: ExportExcelService, private config: PrimeNGConfig) { }

//   ngOnInit(): void {
//     this.retornaDados();
//     this.cols = [
//       { field: 'idPercentualClv', header: 'ID Percentual' },
//       { field: 'descricao', header: 'Descricao' },
//       { field: 'percentual', header: 'Percentual' },
//       { field: 'edit', header: 'Ações', width: '50px' }
//     ];
//   }

//   retornaDados() {
//     this.loading = true;
//     this.service.getDados(`/parametros/listar_percentual`).subscribe(res => {
//       this.totalRegistros = res.length;
//       this.dados = res;
//       this.loading = false;
//     });
//   }

//   onRowEditSave(rowData: any) {
//     // Validação antes de salvar
//     if (!rowData.percentual || rowData.percentual <= 0) {
//       this.messageService.add({
//         severity: 'warn',
//         summary: 'Aviso',
//         detail: 'O valor do percentual deve ser maior que zero.',
//       });
//       return;
//     }

//     // Chamar API para salvar os dados
//     this.atualizarPercentual(rowData.percentual, rowData.idPercentualClv);
//     delete this.editingRows[rowData.idPercentualClv]; // Desabilitar edição
//   }

//   onRowEditCancel(rowData: any) {
//     // Cancelar edição
//     delete this.editingRows[rowData.idPercentualClv];
//     this.retornaDados(); // Recarregar dados originais
//   }

//   editarPercentual(rowData: any) {
//     this.editingRows[rowData.idPercentualClv] = true;
//     console.log('Edição habilitada para:', rowData);
//   }

//   salvarPercentual(dados: any) {
//     this.atualizarPercentual(dados.percentual, dados.idPercentualClv);
//   }

//   atualizarPercentual(percentual: number, idPercentualClv: string) {
//     if (!percentual || typeof percentual !== 'number') {
//       this.messageService.add({
//         severity: 'warn',
//         summary: 'Aviso',
//         detail: 'O valor do percentual deve ser um número válido.',
//       });
//       return;
//     }

//     const url = `/parametros/editar_percentual?percentual=${percentual}&idPercentual=${idPercentualClv}`;
//     this.service.putDados(url, {}).subscribe(
//       () => {
//         this.messageService.add({
//           severity: 'success',
//           summary: 'Sucesso',
//           detail: 'Percentual atualizado com sucesso!',
//         });
//         this.recarregaDados();
//       },
//       () => {
//         this.messageService.add({
//           severity: 'error',
//           summary: 'Erro',
//           detail: 'Erro ao atualizar o percentual. Verifique os dados.',
//         });
//       }
//     );
//   }

//   recarregaDados() {
//     this.filtrosNew.paginaAtual = 1;
//     this.filtrosNew.quantidadeRegistrosPorPagina = 10;
//     this.first = 0;
//     this.retornaDados();
//   }
// }










import { Component, OnInit, ViewChild } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Table } from 'primeng/table';
import { ServiceAppService } from '../../../security/service-app.service';
import { ICadastro, IFiltros } from './interface-porcentual';

@Component({
  selector: 'app-porcentual-clv',
  templateUrl: './porcentual-clv.component.html',
  styleUrls: ['./porcentual-clv.component.scss'],
})
export class PorcentualClvComponent implements OnInit {
  @ViewChild('dt') dt: Table;

  editingRows: { [key: string]: boolean } = {};
  cols: any[];
  dados: any[] = [];
  loading: boolean = false;
  totalRegistros: number = 0;
  filtrosNew: IFiltros = {
    id: '', id_dealer: '', id_categoria_venda: '', mes: '', ano: '', paginaAtual: 1,
    quantidadeRegistrosPorPagina: 10, anoNumber: new Date().getFullYear()
  };
  constructor(private service: ServiceAppService, private messageService: MessageService) {}

  ngOnInit(): void {
    this.retornaDados();
    this.cols = [
      { field: 'idPercentualClv', header: 'ID Percentual' },
      { field: 'descricao', header: 'Descrição' },
      { field: 'percentual', header: 'Percentual' },
      { field: 'edit', header: 'Ações', width: '50px' },
    ];
  }

  retornaDados() {
    this.loading = true;
    this.service.getDados('/parametros/listar_percentual').subscribe(
      (res) => {
        this.dados = res;
        this.totalRegistros = res.length;
        this.loading = false;
      },
      () => {
        this.loading = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Erro ao carregar os dados.',
        });
      }
    );
  }

  // Habilitar edição para uma linha
  editarLinha(rowData: any) {
    this.editingRows[rowData.idPercentualClv] = true;
  }

  salvarLinha(rowData: any) {
    if (!rowData.percentual || rowData.percentual <= 0) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Aviso',
        detail: 'O percentual deve ser maior que zero!',
      });
      return;
    }

    const percentual = rowData.percentual;
    const idPercentualClv = rowData.idPercentualClv;

    // Construir a URL com os parâmetros na query string
    const url = `/parametros/editar_percentual?percentual=${percentual}&idPercentual=${idPercentualClv}`;

    // Chamada para o backend
    this.service.putDados(url, {}).subscribe(
      (res) => {
        // Sucesso
        this.messageService.add({
          severity: 'success',
          summary: 'Sucesso',
          detail: `Percentual do item "${rowData.descricao}" atualizado com sucesso.`,
        });

        // Fechar a linha para edição após o sucesso
        delete this.editingRows[rowData.idPercentualClv];  // Remover a linha da edição

        // Recarregar os dados para refletir as alterações
        this.recarregaDados();
      },
      (error) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Erro ao salvar os dados. Verifique e tente novamente.',
        });
      }
    );
  }





  recarregaDados() {
    this.loading = true; // Exibe o indicador de carregamento

    // Chama o serviço para buscar os dados atualizados
    this.service.getDados('/parametros/listar_percentual').subscribe(
      (res) => {
        this.dados = res.sort((a, b) => a.percentual - b.percentual);
        this.totalRegistros = res.length;
        this.loading = false;
      },
      (error) => {
        this.loading = false; // Oculta o indicador mesmo em caso de erro
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Erro ao carregar os dados. Tente novamente mais tarde.',
        });
      }
    );
  }

  cancelarEdicao(rowData: any) {
    delete this.editingRows[rowData.idPercentualClv];
    this.retornaDados();
  }
}

